import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  OTP_REQUEST_SUCCESS,
  OTP_REQUEST_FAILURE,
} from "../actions/type";

const initialState = {
  token: null,
  isAuthenticated: false,
  user: null,
  otpSent: false,
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case OTP_REQUEST_SUCCESS:
      return {
        ...state,
        otpSent: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        token: payload.token,
        user: {
          id: payload.id,
          mobile: payload.mobile,
          role: payload.role,
        },
        error: null,
      };

    case OTP_REQUEST_FAILURE:
    case LOGIN_FAILURE:
    case LOGOUT:
      return {
        ...initialState,
        error: payload,
      };

    default:
      return state;
  }
}
